import isMobile from '../common/utils/isMobile';
import { Offer, OfferStorage, Settings } from '../domain';

export const getIframeStyles = ({
  contentHeight,
  discountMinHeight,
  settings,
}: {
  contentHeight: number;
  discountMinHeight: string | null;
  settings: Partial<Settings>;
}) => {
  const { bottom_spacing, align_left, side_spacing } = settings;
  const position = align_left ? 'left' : 'right';
  const minHeight = discountMinHeight || 'auto';
  const maxHeight = `calc(${contentHeight === 0 ? 0 : contentHeight}px)`;
  const height = `calc(100vh - 135px - ${bottom_spacing}px)`;
  const top = `calc(max(40px, 100vh - (75px + ${
    contentHeight + (bottom_spacing as number)
  }px)))`;
  const bottom = `${75 + (bottom_spacing ?? 0)}px`;
  const boxShadow = `${isMobile() ? 'none' : '0 5px 40px rgba(0, 0, 0, 0.16)'}`;
  return {
    minHeight,
    maxHeight,
    height,
    top,
    bottom,
    boxShadow,
    [position]: `${side_spacing}px`,
  };
};

export function addedOffersCardFilter(
  addedOffers: OfferStorage[],
  offer: Offer,
): unknown {
  // we need to make sure MultipleProductOffer without selected product is not included in added offers list
  const addedOffer = addedOffers.find(addedOffer => addedOffer.offerId === offer.id)
  return (
    addedOffer &&
    ((offer.type === 'MultipleProductOffer' &&
      addedOffer.productHandle) ||
      offer.type !== 'MultipleProductOffer')
  );
}
